<script>
import ModelMixin from './ModelMixin';
import Component, { mixins } from 'vue-class-component';
import UiFormItem from './UIFormItem';

@Component({
  name: 'UICheckbox',
  inheritAttrs: false,
  props: {
    title: {},
    instructions: {},
    required: Boolean,
    disabled: Boolean,
  },
  components: {
    UiFormItem,
  },
})
export default class UICheckbox extends mixins(ModelMixin) {

}
</script>

<template lang="pug">

div.ui-checkbox(:title="title", :instructions="instructions", :required="required", :root="true", :disabled="disabled")
  label.box-and-title
    input.ui-checkbox-input(v-bind="$attrs", type="checkbox", v-on="$listeners", v-model="internalValue", :disabled="disabled")
    span.title
      slot(name="title") {{ title }}
  span.instructions {{ instructions }}

</template>

<style scoped lang="postcss">
@import "../../styles";

.ui-checkbox {
  & .box-and-title {
    display: flex;
    align-items: center;
    cursor: pointer;
    & .ui-checkbox-input {
      margin-right: var(--spacingXS);
    }

    & .title {
      @apply --f8;
    }
  }

  & .instructions {
    @apply --f7;
  }

  &[disabled] {
    & .box-and-title,
    & .ui-checkbox-input,
    & .instructions {
      cursor: not-allowed;
    }

    & .title {
      color: var(--colorManatee);
    }
  }
}
</style>
